(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["compatibility"] && !Shopify.designMode) return;
  try {
    
  var cards = document.querySelectorAll('.compatibility__card[data-machine-index]');
  var tableWrapper = document.querySelector('.compatibility__table-wrapper');

  cards.forEach(function(card) {
    card.style.cursor = 'pointer';
    card.addEventListener('click', function() {
      var index = this.getAttribute('data-machine-index');
      var isActive = this.classList.contains('compatibility__card--active');

      cards.forEach(function(c) { c.classList.remove('compatibility__card--active'); });
      document.querySelectorAll('.compatibility__table-col-highlight').forEach(function(el) {
        el.classList.remove('compatibility__table-col-highlight');
      });

      if (!isActive) {
        this.classList.add('compatibility__card--active');
        document.querySelectorAll('[data-col="' + index + '"]').forEach(function(cell) {
          cell.classList.add('compatibility__table-col-highlight');
        });

        var headerCell = document.querySelector('.compatibility__table-machine[data-col="' + index + '"]');
        if (headerCell && tableWrapper) {
          var wrapperRect = tableWrapper.getBoundingClientRect();
          var cellRect = headerCell.getBoundingClientRect();
          var scrollLeft = tableWrapper.scrollLeft + cellRect.left - wrapperRect.left - (wrapperRect.width / 2) + (cellRect.width / 2);
          tableWrapper.scrollTo({ left: scrollLeft, behavior: 'smooth' });
        }
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["features-showcase"] && !Shopify.designMode) return;
  try {
    
  var showcaseTabs = document.querySelectorAll('.features-showcase__tab');
  var showcasePanels = document.querySelectorAll('.features-showcase__panel');

  showcaseTabs.forEach(function(tab) {
    tab.addEventListener('click', function() {
      var index = this.getAttribute('data-tab-index');

      showcaseTabs.forEach(function(t) {
        t.classList.remove('features-showcase__tab--active');
        t.setAttribute('aria-selected', 'false');
      });
      showcasePanels.forEach(function(p) {
        p.classList.remove('features-showcase__panel--active');
      });

      this.classList.add('features-showcase__tab--active');
      this.setAttribute('aria-selected', 'true');
      document.getElementById('features-showcase-panel-' + index).classList.add('features-showcase__panel--active');
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["features-tabs"] && !Shopify.designMode) return;
  try {
    
  var tabs = document.querySelectorAll('.features-tabs__tab');
  var panels = document.querySelectorAll('.features-tabs__panel');

  tabs.forEach(function(tab) {
    tab.addEventListener('click', function() {
      var index = this.getAttribute('data-tab-index');

      tabs.forEach(function(t) {
        t.classList.remove('features-tabs__tab--active');
        t.setAttribute('aria-selected', 'false');
      });
      panels.forEach(function(p) {
        p.classList.remove('features-tabs__panel--active');
      });

      this.classList.add('features-tabs__tab--active');
      this.setAttribute('aria-selected', 'true');
      document.getElementById('features-tab-panel-' + index).classList.add('features-tabs__panel--active');
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
